<template>
    <div>
        <el-dialog
            title="服务人员"
            :visible.sync="serviceId.state"
            width="60%"
            class="dialog_container"
            @close="dialogVisibleClone"
            append-to-body
        >
            <!--      <hr style="margin-bottom: 20px" color="#CCCCCC" />-->

           <div class="name-per">
                <div
                    v-for="(item, index) in titleList"
                    :key="index"
                    class="name-list"
                    @click="changeIdx(item.id)"
                >
                    <div>
                        <div
                            class="name-title"
                            :class="{
                                changeColor: controlAddContent == item.id,
                            }"
                        >
                            <div></div>
                            <div><i class="el-icon-circle-check"></i></div>
                            <div></div>
                        </div>
                        <div class="name-bottom">{{ item.name }}</div>
                    </div>
                </div>
            </div>

            <!-- 基本信息 -->
            <el-form
                v-show="controlAddContent == 1"
                :model="formData"
                label-width="90px"
            >
                <div class="infoBox">
                    <div>
                        <el-form-item label="姓名:" required>
                            <el-input
                            disabled
                                v-model="formData.personName"
                                placeholder="请输入"
                                style="width: 475px"
                            ></el-input>
                        </el-form-item>
                        
                        <el-form-item label="身份证号:" prop="personIdentity">
                            <el-input
                            disabled
                                v-model="formData.personIdentity"
                                placeholder="请输入"
                                style="width: 475px"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="性别:" prop="personSex">
                            <el-select
                                v-model="formData.personSex"
                                placeholder="请选择"
                                disabled
                                style="width: 475px"
                            >
                                <el-option label="男" :value="'1'"></el-option>
                                <el-option label="女" :value="'0'"></el-option>
                                <el-option label="女" :value="'2'"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="年龄:">
                            <el-input
                                v-model="formData.personAge"
                                disabled
                                placeholder="请输入"
                                style="width: 475px"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="手机号码:"
                            required
                            prop="personPhone"
                        >
                            <el-input
                            disabled
                                v-model="formData.personPhone"
                                placeholder="请输入"
                                style="width: 475px"
                            ></el-input>
                        </el-form-item>
                    </div>
                    <div class="rightBox">
                        <el-upload
                        disabled	
                            ref="upload"
                            class="avatar-uploader"
                            :action="baseUrl"
                            :show-file-list="false"
                        >
                            <img
                                v-if="formData.personPhoto"
                                :src="formData.personPhoto"
                                class="avatar"
                            />
                            <i
                                v-else
                                class="el-icon-plus avatar-uploader-icon"
                            ></i>
                        </el-upload>
                        <div class="uploadBtn">上传图片</div>
                    </div>
                </div>
                <div class="collegebox">
                    <div>
                        <el-form-item label="毕业院校:">
                            <el-input
                            disabled
                                v-model="formData.graduateUniversity"
                                placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="毕业时间:">
                            <el-date-picker
                            disabled
                                v-model="formData.graduateTime"
                                type="date"
                                placeholder="选择日期"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </div>
                    <div>
                        <el-form-item label="学历：">
                            <el-select
                            disabled
                                v-model="formData.education"
                                placeholder="请选择"
                            >
                                <el-option
                                    label="本科"
                                    :value="'0'"
                                ></el-option>
                                <el-option
                                    label="专科"
                                    :value="'1'"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="所学专业:">
                            <el-input
                            disabled
                                v-model="formData.speciality"
                                placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="addressFrom">
                    <div class="addressTitle"><span>*</span>地址:</div>
                    <div class="addressContent">
                        <div class="addressBox">
                            <div class="addressItem">
                                <el-form-item prop="provinceId">
                                    <el-select
                                        v-model="formData.provinceId"
                                        placeholder="请选择省"
                                        disabled
                                        ref="selectShengChange"
                                    >
                                        <el-option
                                            v-for="(
                                                item, index
                                            ) in provinceList"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.adcode"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="addressItem">
                                <el-form-item prop="cityid">
                                    <el-select
                                        disabled
                                        v-model="formData.cityid"
                                        placeholder="请选择市"
                                        ref="selectShiChange"
                                    >
                                        <el-option
                                            v-for="(item, index) in cityList"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.adcode"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="addressItem">
                                <el-form-item prop="zoneid">
                                    <el-select
                                        disabled
                                        v-model="formData.zoneid"
                                        placeholder="请选择区"
                                        ref="selectQuChange"
                                    >
                                        <el-option
                                            v-for="(item, index) in areaList"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.adcode"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="addressItem">
                                <el-form-item prop="streetid">
                                    <el-select
                                        disabled
                                        v-model="formData.streetid"
                                        placeholder="请选择街道"
                                        ref="selectJiedaoChange"
                                    >
                                        <el-option
                                            v-for="(item, index) in streetList"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.adcode + index"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="addressItem">
                                <el-form-item prop="shequid">
                                    <el-select
                                        disabled
                                        v-model="formData.shequid"
                                        placeholder="请选择社区"
                                        ref="selectShequChange"
                                    >
                                        <el-option
                                            v-for="item in communityList"
                                            :key="item.id"
                                            :label="item.address"
                                            :value="item.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                        <el-form-item prop="address">
                            <input
                                v-model.trim="formData.address"
                                disabled
                                id="tipinput"
                                class="el-input__inner"
                                @focus="getMap('tipinput')"
                                placeholder="请输入关键字"
                                autocomplete="off"
                            />
                        </el-form-item>
                        <div class="map_container">
                            <div
                                id="container1"
                                style="width: 100%; height: 300px"
                            ></div>
                        </div>
                    </div>
                </div>
                <el-form-item
                    label="是否工作人员："
                    label-width="140px"
                    prop="isWork"
                >
                    <el-radio-group v-model="formData.isWork">
                        <el-radio label="0">是</el-radio>
                        <el-radio label="1">否</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <!-- 培训记录 -->
            <div v-show="controlAddContent == 2">
                <el-table
                    :data="recordData"
                    border
                    style="width: 100%"
                >
                    <el-table-column
                        type="index"
                        width="70"
                        label="序号"
                        align="center"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="theme"
                        label="培训主题"
                        align="center"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="speaker"
                        label="主讲人"
                        align="center"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="time"
                        label="培训时间"
                        align="center"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="skillName"
                        label="培训技能"
                        align="center"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="350">
                        <template slot-scope="scope">
                            <el-link
                                :underline="false"
                                @click="recordHandle(scope.row.id)"
                                >查看</el-link
                            >
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 证书信息 -->
            <div v-show="controlAddContent == 3">
                <div class="btn_group">
                    <el-button
                    disabled	
                        type="success"
                        icon="iconfont icon-xinzeng"
                        @click="lookCer1('新增', 'add')"
                        >新增</el-button
                    >
                </div>
                <el-table
                    :data="formData.certificateList"
                    border
                    style="width: 100%"
                >
                    <el-table-column
                        type="index"
                        width="70"
                        label="序号"
                        align="center"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="certificateTypeName"
                        label="证书类型"
                        align="center"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="certificateName"
                        label="证书名称"
                        align="center"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="certificateCode"
                        label="证书编码"
                        align="center"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <!-- <el-table-column label="操作" align="center" width="350">
                        <template slot-scope="scope">
                            <el-row>
                                <el-col :span="6">
                                    <el-link
                                        :underline="false"
                                        @click="lookCer1('查看', scope.row)"
                                        >查看</el-link
                                    >
                                </el-col>
                                <el-col :span="6">
                                    <el-link
                                        :underline="false"
                                        @click="
                                            lookCer2(
                                                '编辑',
                                                scope.row,
                                                scope.$index
                                            )
                                        "
                                        >编辑</el-link
                                    >
                                </el-col>
                                <el-col :span="6">
                                    <el-link
                                        :underline="false"
                                        @click="delCer(scope.row,scope.$index)"
                                        >删除</el-link
                                    >
                                </el-col>
                            </el-row>
                        </template>
                    </el-table-column> -->
                </el-table>
            </div>
           
        </el-dialog>
        <!-- 查看弹窗 -->
<el-dialog title="查看" :visible.sync="recordDialogVisible" width="50%">
            <hr style="margin-bottom: 20px" />
            <el-form ref="recordFormRef" :model="recordForm" label-width="80px">
                <el-form-item label="主题培训:">
                    <el-input
                        v-model="recordForm.theme"
                        disabled
                        placeholder="请输入"
                    ></el-input>
                </el-form-item>
                <el-form-item label="主讲人:">
                    <el-input
                        v-model="recordForm.speaker"
                        disabled
                        placeholder="请输入"
                    ></el-input>
                </el-form-item>
                <el-form-item label="培训时间:">
                    <el-col :span="11">
                        <el-date-picker
                            type="date"
                            placeholder="请选择开始时间"
                            v-model="recordForm.startTime"
                            disabled
                            style="width: 100%"
                        ></el-date-picker>
                    </el-col>
                    <el-col class="line" :span="2">至</el-col>
                    <el-col :span="11">
                        <el-date-picker
                            type="date"
                            placeholder="请选择结束时间"
                            disabled
                            v-model="recordForm.endTime"
                            style="width: 100%"
                        ></el-date-picker>
                    </el-col>
                </el-form-item>
                <el-form-item label="培训地点:">
                    <el-input
                        v-model="recordForm.place"
                        disabled
                        placeholder="请输入"
                    ></el-input>
                </el-form-item>
                <el-form-item label="培训技能:">
                    <el-input
                        v-model="recordForm.skillName"
                        disabled
                        placeholder="请输入"
                    ></el-input>
                </el-form-item>
                <el-form-item label="培训内容:">
                    <quillEditor  v-model="recordForm.content" disabled></quillEditor>
                </el-form-item>
                
            </el-form>
        </el-dialog>
   </div>
</template>
<script>
import request from "@/utils/request.js"
import baseURL from "@/api/baseURL"
import { quillEditor } from "vue-quill-editor"
export default {
    props: ["serviceId"],
   components:{
       quillEditor
   },
    data() {
        return {
            recordDialogVisible:false,
            recordForm: {
                theme: "",
                speaker: "",
                date1: "",
                date2: "",
                site: "",
                skill: "",
                condition: "",
                manifestation: "",
                content:'10010'
            },
            query: {
                pageNo: 1,
                pageSize: 10,
            },
            dialogVisible: false,
            formData: {},
            serviceTypeList:[],
             provinceList: [], //
            cityList: [],
          areaList: [],
          streetList: [],
          polygons: [],
          communityList: [],
            street:'',
            infoData:[],
            recordData:[],
            titleList: [
                 {
                    id: "1",
                    name: "基本信息",
                },
                {
                    id: "2",
                    name: "培训记录",
                },
                {
                    id: "3",
                    name: "证书信息",
                },
            ],
              servestation: {
                pageNo: 1,
                pageSize: 5,
                count: 0,
                list: [],
            },
            total1: 0,
            healthCondition: [],
             controlAddContent: "1", // 控制新增弹框内部内容的切换
        }
    },
    created(){
        this.baseUrl = baseURL + "/sqyl/controller/uploadController/info/uploadPhoto";
         
    },
    async mounted() {
        this.getData()
        await this.$nextTick(function () {
            setTimeout(() => {
                this.loadMap()
                // this.getServestation()
            }, 30)
        })
    },
    methods: {
        recordHandle(id){
            this.recordDialogVisible=true
              this.$http
                .request({
                    url: "/sqyl/admin/train/info/getInfoById",
                    method: "POST",
                    data: {id:id},
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        if (res.content) {
                            this.recordForm = res.content
                            } else {
                                this.recordForm = []
                            }
                    }
                })
       },
        dialogVisibleClone() {
            this.$emit("setService")
            this.dialogVisible = false
        },
        changeIdx(id) {
            this.controlAddContent = id;
             this.getServerList()
        },
        getData() {
            request({
                url: "/sqyl/admin/servicePerson/info/getById",
                method: "POST",
                data: {
                    id: this.serviceId.id,
                },
            }).then(async (res) => {
                if (res.code == 200) {
                    this.formData = res.content
                     let province = await this.getDistricts()
                    this.provinceList = province.districtList
                      this.formData.streetid = String(res.content.streetId)
                      this.formData.shequid = Number(res.content.shequid)
                       if (!this.formData.provinceId) return
                        let city = await this.getDistricts(this.formData.provinceId)
                        this.cityList = city.districtList
                        if (!this.formData.cityid) return
                        let area = await this.getDistricts(this.formData.cityid)
                        this.areaList = area.districtList
                        if (!this.formData.zoneid) return
                        let street = await this.getDistricts(this.formData.zoneid)
                        this.streetList = street.districtList

                        if (!this.formData.streetId) return
                        let communityList = await this.getCommityList(
                            this.formData.streetId
                        )
                        this.communityList = communityList
                        this.formData.latitude = res.content.latitude
                        this.formData.longitude = res.content.longitude
                         setTimeout(async () => {
                            await this.$nextTick(() => {
                                this.loadMap("container1")
                                this.potintMap()
                            })
                            }, 30)
                            this.getrecordData(this.formData.id)
                        this.$forceUpdate()
                } else if (res.code == "10004") {
                    this.$message.error(res.message)
                    this.$router.push("/login")
                }
            })
        },
        
           getrecordData(id){
            this.$http
                .request({
                    url: "/sqyl/admin/train/info/findTrainByPersonList",
                    method: "POST",
                    data: {
                        personId:id,
                        pageSize:'10',
                        pageNo:'1'
                        },
                })
                .then(async (res) => {
                    console.log(res)
                    if (res.code == 200) {
                        console.log(res)
                        if (res.content.list) {
                            res.content.list.forEach((item) => {
                                item.time = item.startTime + "至" + item.endTime
                                //console.log(item.time,"查询")
                            })
                            this.recordData = res.content.list
                            this.recordData=this.recordData.filter((item)=> item && (item.partSituation==1 || item.partSituation==3))
                            } else {
                                this.recordData = []
                            }
                    }
                })
       },
        loadMap() {
            //地图加载
            return new Promise((resolve, reject) => {
                this.myMap = new AMap.Map("container1", {
                    resizeEnable: true,

                    zoom: 8,
                })
                resolve()
            })
        },
         potintMap() {
      const self = this
      try {
        self.myMap.remove(self.marker)
      } catch (err) {
        console.log(err)
      }
      self.marker = new AMap.Marker({
        icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        position: [
          Number(self.formData.addressLng),
          Number(self.formData.addressLat),
        ],
      })
      console.log(self.myMap)
      self.myMap.add(self.marker)
      self.myMap.setFitView()
    },
        // 社区地址列表
        getCommityList(val) {
        let self = this;
        return new Promise((resolve, reject) => {
            self.$http
            .request({
                url: "/ypt/admin/standardAddress/info/StandardAddressTree",
                method: "POST",
                data: {
                jiedaoId: val,
                },
            })
            .then((res) => {
                if (res.code == 200) {
                if (!res.content) {
                    resolve([]);
                    return;
                }
                resolve(res.content);
                } else {
                resolve([]);
                }
            });
        }).catch((err) => {
        });
        },
        // 地图
        getMap(input) {
        const self = this;
        const autoOptions = {
            city: self.formData.quId,
            citylimit: true,
            input: input,
        };
        // alert(input)
        const auto = new AMap.Autocomplete(autoOptions);
        //构造地点查询类
        AMap.event.addListener(auto, "select", (e) => {
            self.formData.address = e.poi.name;
            self.formData.longitude = e.poi.location.lng;
            self.formData.latitude = e.poi.location.lat;
            self.potintMap();
        });
        },
        //获取地址
        getDistricts(name = "中国", params = null) {
        let self = this;
        return new Promise((resolve, reject) => {
            var opts = {
            subdistrict: 1, //返回下一级行政区
            extensions: "all",
            showbiz: false, //最后一级返回街道信息
            };
            let district = new AMap.DistrictSearch(opts);
            let geocoder = new AMap.Geocoder({
            city: "", //城市设为北京，默认：“全国”
            radius: 1000, //范围，默认：500
            });
            try {
            self.myMap.remove(self.marker);
            } catch (err) {
            }

            self.marker = new AMap.Marker();
            district.search(name, (status, result) => {
            if (status == "complete") {
                resolve(result.districtList[0]);
                if (this.isMap) {
                this.isMap = false;
                return;
                }
                let bounds = result.districtList[0].boundaries;
                self.polygon = null;
            }
            });
        }).catch((err) => {
        });
        },
        //  servestationRow(row) {
        //     // alert(row.statName)
        //     if (this.dialogTitle != "查看") {
        //         this.$nextTick(() => {
        //             this.formData.serviceStationId = row.id
        //             this.formData.serviceStationName = row.statName
        //             this.$forceUpdate()
        //         })
        //     }
        // },
        getServestation() {
            this.$http
                .request({
                    url: "/jjyl/admin/serviceStation/info/findList",
                    method: "POST",
                    data: {
                        pageNo: this.servestation.pageNo,
                        pageSize: this.servestation.pageSize,
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content) {
                            this.servestation = res.content
                        } else {
                            this.servestation = {
                                pageNo: 1,
                                pageSize: 5,
                                count: 0,
                                list: [],
                            }
                        }
                    }
                })
        },
         servestationSize(val) {
            this.servestation.pageNo = val
            this.getServestation()
        },
        servestationChange(val) {
            this.servestation.pageNo = 1
            this.servestation.pageSize = val
            this.getServestation()
        },
         //服务工单列表
        getServerList() {
            if (this.dialogTitle !== "新增") {
                this.$http
                    .request({
                        url: "/jjyl/servicePgd/info/findServicepgdByServepersonID",
                        method: "POST",
                        data: {
                            servePerson_id: this.getServerId,
                        },
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            if (res.content == null || res.content == "null") {
                                this.infoData = []
                                return
                            }
                            this.infoData = res.content
                        }
                    })
            }
        },
    },
}
</script>

<style lang="less" scoped>
.name-per {
    width: 90%;
    margin: 0 auto;
    display: flex;
    margin-bottom: 20px;
}

.name-list {
    width: 50%;
    cursor: pointer;
    display: flex;
    justify-content: center;
}

.name-list > div:first-child {
    width: 100%;
}

.name-title {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.name-title > div:first-child {
    width: 50%;
    height: 2px;
    background-color: #eeeeee;
}

.name-title > div:last-child {
    width: 50%;
    height: 2px;
    background-color: #eeeeee;
}

.name-bottom {
    width: 100%;
    text-align: center;
}

.changeColor > div:first-child {
    background-color: #0000ff;
}

.changeColor > div:nth-child(2) {
    color: #0000ff;
}

.changeColor > div:last-child {
    background-color: #0000ff;
}

.operation-color:hover {
    color: #00aaff;
}

.bottom-page {
    margin: 20px 0;
}

.btn_group {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
}

.dialog-footer {
    width: 100%;
    display: flex;
    margin-top: 20px;
    justify-content: center;
}

.collegebox {
    display: flex;
    width: 100%;
    justify-content: flex-start;
}

.infoBox {
    display: flex;
    width: 100%;
    justify-content: flex-start;
}

.serviceInfoBox {
    display: flex;
    width: 100%;
    justify-content: flex-start;
}

.rightBox {
    margin-left: 30px;
    text-align: center;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.row-bg {
    margin-bottom: 20px;
}

.rightBox {
    margin-left: 30px;
    text-align: center;
}

.uploadBtn {
    width: 178px;
    height: 50px;
    margin-left: 5px;
    background-color: #66b1ff;
    color: #fff;
    font-size: 18px;
    border-radius: 5px;
    line-height: 50px;
    margin-top: 20px;
}

.el-dialog__body {
    padding-top: 0;
}
.addressFrom {
    display: flex;
    margin-left: -50px;
    margin-bottom: 20px;
    .addressTitle {
        text-align: right;
        vertical-align: middle;
        width: 140px;
        font-size: 14px;
        color: #606266;
        line-height: 40px;
        padding: 0 12px 0 0;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        span {
            color: #f56c6c;
            margin-right: 4px;
        }
    }
    .addressContent {
        flex: 1;
        .addressBox {
            display: flex;
            .addressItem {
                flex: 1;
                .el-form-item {
                    /deep/.el-form-item__content {
                        margin-left: 0px !important;
                    }
                }
                /deep/.el-select {
                    width: 100% !important;
                }
            }
        }
        .el-form-item {
            /deep/.el-form-item__content {
                margin-left: 0px !important;
            }
        }
    }
}
</style>